exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2X0EnjYl_kQqjXRkisd2KC>div{max-width:400px}", ""]);

// exports
exports.locals = {
	"undoSendSlider": "_2X0EnjYl_kQqjXRkisd2KC"
};